<template>
  <div id="hall-manage">
    <!--搜索-->
    <div class="top">
      <el-col :span="8">
        <el-input placeholder="请输入内容" v-model="input" class="input-with-select" style="width: 100%">
          <el-button slot="append" icon="el-icon-search" @click="search">搜索</el-button>
        </el-input>
      </el-col>
      <el-col :span="2" :offset="1">
        <el-button type="primary" size="small" @click="loadaddPcode">生成邀请码</el-button>

      </el-col>
      <el-col :span="8" class="invitation-code">
        <el-input v-model="invitationCode" :readonly="true" style="width: 100%" />
      </el-col>
    </div>
    <!--表格-->
    <div class="hall-table">
      <el-table
        border
        :data="tableData"
      >
        <el-table-column
          label="受邀人"
          align="center"
          width="600"
          prop="username">
        </el-table-column>
        <el-table-column
          label="注册日期"
          align="center"
          prop="created">
        </el-table-column>

      </el-table>
    </div>
    <!--分页-->
    <div class="block" v-if="tableData.length">
      <el-pagination
        @current-change="currentChange"
        background
        layout="prev, pager, next"
        :page-size="8"
        :page-count="total">
      </el-pagination>
    </div>

  </div>
</template>


<script>
    import {MessageBox,Message} from 'element-ui'
    import {getCurrentPageBHall,addPcode} from "../../../api";
    import Vue from "vue"
    export default {
        name: "HallManage",
        data(){
          return{
            tableData:[],
            total:0,
            invitationCode:'',
            currentPage:1,
            username:'',
            created:'',
            hallInfo:{},
            hallTypeList: [],
            dialogFormVisible:false,
            dialogTitle:'',
            labelPosition:'right',
            input:'',
            searchInput:'',
            hallOldName:'',
            addDialogFormVisible:false,
            seatDialogFormVisible:false,
            loadingDialogFormVisible:false,
            seat:[[]],
            seats: [],
            changeSeat:[],
            newSeat:[],
            addHallTypeId:'',
            xSeat:15,
            ySeat:15,

            rules: {
              addHallTypeId: [
                { required: true, message: '影厅名不能为空', trigger: 'blur' },
              ]
            },
          }
        },
        created(){
          this.loadCurrentPageHall(this.currentPage,8,'');
        },

        methods:{
          async loadCurrentPageHall(currentPage,pageSize,input){
            const uid  = this.$cookies.get("uid");
            let json = await getCurrentPageBHall(currentPage,pageSize,input,uid);
            if (json.code==='200'){
              this.tableData = json.data;
              this.total = Math.ceil(json.total / 10);
            }
          },

          async currentChange(currentPage){
            this.currentPage = currentPage;
            this.loadCurrentPageHall(this.currentPage,8,this.searchInput);
          },

          //搜索影院
          search(){
            this.searchInput = this.input;
            this.loadCurrentPageHall(1,8,this.searchInput);
          },
          cancel(){
            this.loadCurrentPageHall(this.currentPage,8,this.searchInput);
            this.dialogFormVisible = false;
          },
          async loadaddPcode() {
  const uid = this.$cookies.get("uid");

  let json = await addPcode(uid);
  console.log(json)
  if (json.code === '200') {
    Message.success(json.msg);
    this.invitationCode = json.data;
  }
},



        }
    }
</script>

<style>
  .hall-table{
    width:90%;
    min-width:900px;
    margin: 0 auto;
    margin-bottom: 30px;
  }
  .top{
    display: flex;
    justify-content: center;
    align-items: center;
    /* padding: 30px 0; */
    margin-bottom: 30px;
  }
  .block{
    text-align: center;
  }
  .el-dialog__header{
    text-align: center;
  }
  .el-dialog__body .el-form-item{
    width: 80%;
    padding-left: 20%;
  }
  .x {
    display: flex;
    flex-direction: row;
  }
  .y {
    display: flex;
    flex-direction: column;
  }
  .img {
    margin: 1px;
    height: 30px;
    width: 30px;
  }
  .seat {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    justify-content: flex-start;
    align-items: center;
  }
  .sk-fading-circle {
  width: 4em;
  height: 4em;
  position: relative;
  margin: auto;
}
.sk-fading-circle .sk-circle {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.sk-fading-circle .sk-circle:before {
  content: '';
  display: block;
  margin: 0 auto;
  width: 15%;
  height: 15%;
  background-color: #337ab7;
  border-radius: 100%;
  -webkit-animation: sk-fading-circle-delay 1.2s infinite ease-in-out both;
          animation: sk-fading-circle-delay 1.2s infinite ease-in-out both;
}
.sk-fading-circle .sk-circle-2 {
  -webkit-transform: rotate(30deg);
          transform: rotate(30deg);
}
.sk-fading-circle .sk-circle-3 {
  -webkit-transform: rotate(60deg);
          transform: rotate(60deg);
}
.sk-fading-circle .sk-circle-4 {
  -webkit-transform: rotate(90deg);
          transform: rotate(90deg);
}
.sk-fading-circle .sk-circle-5 {
  -webkit-transform: rotate(120deg);
          transform: rotate(120deg);
}
.sk-fading-circle .sk-circle-6 {
  -webkit-transform: rotate(150deg);
          transform: rotate(150deg);
}
.sk-fading-circle .sk-circle-7 {
  -webkit-transform: rotate(180deg);
          transform: rotate(180deg);
}
.sk-fading-circle .sk-circle-8 {
  -webkit-transform: rotate(210deg);
          transform: rotate(210deg);
}
.sk-fading-circle .sk-circle-9 {
  -webkit-transform: rotate(240deg);
          transform: rotate(240deg);
}
.sk-fading-circle .sk-circle-10 {
  -webkit-transform: rotate(270deg);
          transform: rotate(270deg);
}
.sk-fading-circle .sk-circle-11 {
  -webkit-transform: rotate(300deg);
          transform: rotate(300deg);
}
.sk-fading-circle .sk-circle-12 {
  -webkit-transform: rotate(330deg);
          transform: rotate(330deg);
}
.sk-fading-circle .sk-circle-2:before {
  -webkit-animation-delay: -1.1s;
          animation-delay: -1.1s;
}
.sk-fading-circle .sk-circle-3:before {
  -webkit-animation-delay: -1s;
          animation-delay: -1s;
}
.sk-fading-circle .sk-circle-4:before {
  -webkit-animation-delay: -0.9s;
          animation-delay: -0.9s;
}
.sk-fading-circle .sk-circle-5:before {
  -webkit-animation-delay: -0.8s;
          animation-delay: -0.8s;
}
.sk-fading-circle .sk-circle-6:before {
  -webkit-animation-delay: -0.7s;
          animation-delay: -0.7s;
}
.sk-fading-circle .sk-circle-7:before {
  -webkit-animation-delay: -0.6s;
          animation-delay: -0.6s;
}
.sk-fading-circle .sk-circle-8:before {
  -webkit-animation-delay: -0.5s;
          animation-delay: -0.5s;
}
.sk-fading-circle .sk-circle-9:before {
  -webkit-animation-delay: -0.4s;
          animation-delay: -0.4s;
}
.sk-fading-circle .sk-circle-10:before {
  -webkit-animation-delay: -0.3s;
          animation-delay: -0.3s;
}
.sk-fading-circle .sk-circle-11:before {
  -webkit-animation-delay: -0.2s;
          animation-delay: -0.2s;
}
.sk-fading-circle .sk-circle-12:before {
  -webkit-animation-delay: -0.1s;
          animation-delay: -0.1s;
}

@-webkit-keyframes sk-fading-circle-delay {
  0%, 39%, 100% {
    opacity: 0;
  }
  40% {
    opacity: 1;
  }
}

@keyframes sk-fading-circle-delay {
  0%, 39%, 100% {
    opacity: 0;
  }
  40% {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/business/children/HallManage.vue